import {isAfter} from 'date-fns';

import {SalesActivityTypeEnum} from '@dms/api/sales';

import {parseDate} from 'shared/web';

interface ActivityWithTestDrive {
  id: string;
  activityType: SalesActivityTypeEnum;
  timestamp: string;
  relatedTestDrive: {
    id: string;
    scheduledAt: string;
  } | null;
}

interface LatestTestDriveEvent {
  activityType: SalesActivityTypeEnum;
  activityId: string;
  timestamp: Date;
}

export function getUpcomingTestDrives<T extends ActivityWithTestDrive>(activities: T[]): T[] {
  const now = new Date();

  const latestEventByTestDrive = activities.reduce<Record<string, LatestTestDriveEvent>>(
    (acc, activity) => {
      const testDriveId = activity.relatedTestDrive?.id;
      if (!testDriveId) {
        return acc;
      }

      const parsed = parseDate(activity.timestamp);
      const existing = acc[testDriveId];

      if (!existing || parsed > existing.timestamp) {
        return {
          ...acc,
          [testDriveId]: {
            activityType: activity.activityType,
            activityId: activity.id,
            timestamp: parsed,
          },
        };
      }

      return acc;
    },
    {}
  );

  return activities.filter((activity) => {
    const testDriveId = activity.relatedTestDrive?.id;
    if (!testDriveId) {
      return false;
    }

    const latest = latestEventByTestDrive[testDriveId];

    return (
      activity.activityType === 'TEST_DRIVE_PLANNED' &&
      activity.relatedTestDrive?.scheduledAt &&
      isAfter(parseDate(activity.relatedTestDrive.scheduledAt), now) &&
      latest?.activityType === 'TEST_DRIVE_PLANNED' &&
      latest?.activityId === activity.id
    );
  });
}
